import { Button, Field, Label, TextError } from '@workspace/core-ts/components';
import { ErrorMessage } from '@hookform/error-message';
import { Controller, useFormContext } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { FormSchemaType } from '../../schema';

interface ButtonVehiculierProps {
    index: number;
    disabled?: boolean;
}

export function ButtonVehiculier({ index, disabled }: ButtonVehiculierProps) {
    const methods = useFormContext<FormSchemaType>();
    const setSearchParams = useSearchParams()[1];

    return (
        <Controller
            control={methods.control}
            name={`DemandeTarif.ListeVehicules.${index}.Marque`}
            render={() => (
                <Field>
                    <Label required>Marque et modèle</Label>
                    <Button
                        aria-label="Sélectionner une marque et un modèle"
                        arrow={false}
                        className="rounded-md px-3 w-full"
                        disabled={disabled}
                        onClick={() => {
                            setSearchParams({ modal: 'vehiculier', index } as any);
                        }}
                        size="xs"
                        variant={methods.watch(`DemandeTarif.ListeVehicules.${index}.Marque`) ? 'outline' : 'primary'}
                    >
                        {methods.watch(`DemandeTarif.ListeVehicules.${index}.Marque`)
                            ? `${methods.watch(`DemandeTarif.ListeVehicules.${index}.Marque`)} ${methods.watch(`DemandeTarif.ListeVehicules.${index}.Modele`)}`
                            : 'Sélectionner une marque et un modèle'}
                    </Button>
                    <ErrorMessage errors={methods.formState.errors} name={`DemandeTarif.ListeVehicules.${index}.Marque`} render={({ message }) => <TextError>{message}</TextError>} />
                </Field>
            )}
            rules={{
                required: {
                    value: true,
                    message: 'Veuillez sélectionner une marque et un modèle',
                },
                validate: {
                    isUnder4000: () => {
                        const vehicule = methods.getValues(`DemandeTarif.ListeVehicules.${index}`);

                        if (vehicule.PrixOrigine && vehicule.PrixOrigine >= 4000) {
                            return 'La valeur du véhicule doit être inférieure à 4000€';
                        }
                        return true;
                    },
                },
            }}
        />
    );
}
